import i18n from "@/i18n";

const LeaseType = {
    1: i18n.t("land_leases.type_land_lease_solar"),
    2: i18n.t("land_leases.type_land_lease_wind"),
    3: i18n.t("land_leases.type_compensation"),
    4: i18n.t("land_leases.type_option_purchase"),
    5: i18n.t("land_leases.type_power_of_attorney"),
    6: i18n.t("land_leases.type_option_co_owner"),
    7: i18n.t("land_leases.type_addendum")
};

const PartyType = {
    1: i18n.t("land_leases.party_type_landowner"),
    2: i18n.t("land_leases.party_type_neighbor")
};

const LeaseStatus = {
    1: i18n.t("land_leases.status_draft"),
    2: i18n.t("land_leases.status_under_negotiation"),
    3: i18n.t("land_leases.status_sent"),
    4: i18n.t("land_leases.status_signed"),
    5: i18n.t("land_leases.status_expired"),
    6: i18n.t("land_leases.status_cancelled")
};

const ExceptionChangeType = {
    1: i18n.t("land_leases.change_type_change"),
    2: i18n.t("land_leases.change_type_addendum")
};

export { LeaseType, PartyType, LeaseStatus, ExceptionChangeType };
